import { AfterViewInit, Component, ElementRef, Input } from '@angular/core';

@Component({
  selector: 'lib-select-card',
  templateUrl: './select-card.component.html',
  styleUrls: ['./select-card.component.scss'],
})
export class SelectCardComponent implements AfterViewInit {
  @Input() icon = '';
  @Input() title = '';
  @Input() description = '';
  @Input() showArrow = false;
  @Input() disabled = false;
  @Input() disabledMessage = '';

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    this.el.nativeElement.addEventListener(
      'click',
      (e: MouseEvent) => {
        if ((e.target as HTMLElement).tagName === 'A') {
          e.stopImmediatePropagation();
        }
      },
      true
    );
  }
}
